// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3Og0L","fileBtn":"File_fileBtn__x_OMs","closeBtn":"File_closeBtn__2yuh3","fileSelected":"File_fileSelected__3wr73","disabled":"File_disabled__1kFYm"};